import * as angular from 'angular';
import * as _ from 'lodash';

interface IPasswordScope extends angular.IScope {
    type: string;
    name: string;
    mask: boolean;
    placeholder: string;
    valid: boolean;
    required: boolean;
    model: string;
    capsLockOn: boolean;
    change: (value: any) => void;
    keyup: (event: KeyboardEvent) => void;
    detectCapsLock: (event: KeyboardEvent) => void;
    clearCapsLock: () => void;
}

class PasswordDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        name: '@?',
        mask: '=?',
        placeholder: '@?',
        pattern: '@?',
        required: '=?ngRequired',
        model: '=ngModel',
        keyup: '&?ngKeyup',
        change: '&?ngChange'
    };

    readonly require = 'ngModel';
    readonly template = `
        <div class="fc-password" ng-class="{ 'fc-password-caps-lock-active': capsLockOn }">
            <div class="fc-password-group input-group">
                <input class="input-group-field" type="{{ type }}" name="{{ name }}" placeholder="{{ placeholder }}" pattern="{{ pattern }}" ng-required="required" ng-model="model" ng-keyup="keyup($event)" ng-keypress="detectCapsLock($event)" ng-blur="clearCapsLock()" ng-change="change(value)" novalidate />
                <span class="fc-password-caps-lock input-group-label" ng-show="capsLockOn">Caps lock is on</span>
            </div>
        </div>
    `;

    readonly link: angular.IDirectiveLinkFn;
    private readonly LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(scope: IPasswordScope): void {
        scope.type = this.getType(scope.mask);
        scope.capsLockOn = false;

        scope.detectCapsLock = event => {
            const key = String.fromCharCode(event.keyCode || event.which);
            scope.capsLockOn = !event.shiftKey && _.some(this.LETTERS, letter => letter === key);
        };

        scope.clearCapsLock = () => {
            scope.capsLockOn = false;
        };

        // Watch for scope changes
        scope.$watch(
            () => scope.mask,
            mask => (scope.type = this.getType(mask))
        );

        scope.$watch(
            () => scope.required,
            required => (scope.required = required)
        );
    }

    private getType(mask: boolean): string {
        return mask === false ? 'text' : 'password';
    }
}

const PasswordDirectiveFactory: angular.IDirectiveFactory = () => new PasswordDirective();

export { PasswordDirectiveFactory };
